import { Outlet } from "react-router-dom";
import ModalConfirmUserDeletion from "src/common/components/Modal/ModalConfirmUserDeletion";

/**
 * Story 19.2: Wrapper component for project-group learners routes
 * Provides shared modal for learner management sub-routes.
 * Navigation is handled by parent ProjectGroupEdit (which renders tabs + breadcrumbs).
 */
const ProjectGroupLearnersWrapper = () => {
  return (
    <>
      <Outlet />
      <ModalConfirmUserDeletion />
    </>
  );
};

export default ProjectGroupLearnersWrapper;
